import React from 'react';
import PropTypes from 'prop-types';
import { DMSType } from '@upstart/harmony/lib/legos/dmsTypes';

const DMS_NAME_MAP = {
  [DMSType.CDK]: 'CDK',
};

const ReviewRicButton = ({
  dmsType,
  dealId,
  financeResponseId,
  sentToDMS,
  isUpstartOffer,
  isDMSFlowEnabled,
  onPushToDMS,
  showOfferAndRicTab,
}) => {
  const reviewRicButton = (
    <button
      className="btn btn-primary pencil-button"
      data-testid="review-ric-button"
      onClick={showOfferAndRicTab}
      type="button"
    >
      {' '}
      Review RIC{' '}
    </button>
  );

  const pushToDMSButton = (
    <button
      type="button"
      data-testid="push-to-dms-button"
      className="btn btn-primary pencil-button"
      onClick={onPushToDMS}
    >
      Push to {DMS_NAME_MAP[dmsType]}
    </button>
  );
  const getButtonForDMSFlow = () => {
    if (isDMSFlowEnabled) {
      if (isUpstartOffer) {
        if (sentToDMS) {
          return reviewRicButton;
        }
        return pushToDMSButton;
      }

      if (sentToDMS) {
        return null;
      }
      return pushToDMSButton;
    }
    if (isUpstartOffer) {
      return reviewRicButton;
    }
    return null;
  };

  return getButtonForDMSFlow();
};

ReviewRicButton.propTypes = {
  dmsType: PropTypes.string,
  dealId: PropTypes.string,
  financeResponseId: PropTypes.string,
  sentToDMS: PropTypes.bool,
  isUpstartOffer: PropTypes.bool,
  isDMSFlowEnabled: PropTypes.bool,
  onPushToDMS: PropTypes.func,
  showOfferAndRicTab: PropTypes.func,
};

export default ReviewRicButton;
